import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import PageLayout from 'components/layout/pageLayout'
import SubNavigation from 'components/layout/subNavigation'
import Head from 'components/layout/head'

interface ManualProps extends RouteComponentProps<any> {
  authenticated: boolean
  dispatch: any
}

type ManualState = {}

class Manual extends Component<ManualProps, ManualState> {
  constructor(props: ManualProps) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <PageLayout pageTitle="Hilfe">
        <Head headline="Hilfe & Hinweise" subheadline="Mengenermittlung und Systemsuche - HORST" />
        <SubNavigation
          items={[
            {
              label: 'Bedienung',
              link: '/help/manual',
            },
            {
              label: 'Nutzungshinweise',
              link: '/help/terms-of-use',
            },
            {
              label: 'Links',
              link: '/help/links',
            },
            {
              label: 'Impressum',
              link: 'https://www.rigips.at/impressum',
            },
          ]}
        />
        <div className="px-48 mb-65">
          <iframe
            title="RiKS Bedienungsanleitung"
            style={{ width: '100%', height: '1050px' }}
            src="https://riks.service-rigips.de/App_Themes/Riks/pdf/Bedienungsanleitung_RiKS_2016_11_16.pdf"
          />
        </div>
      </PageLayout>
    )
  }
}

export default Manual
